"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Banner = void 0;
var _uiKit = require("@cian/ui-kit");
var React = _interopRequireWildcard(require("react"));
var _assets = require("../../assets");
var styles = _interopRequireWildcard(require("./Banner.css"));
var _mortgageLink = require("../../constants/mortgageLink");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Banner = _ref => {
  let {
    onButtonClick
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: styles['banner']
  }, /*#__PURE__*/React.createElement("img", {
    src: _assets.logo
  }), /*#__PURE__*/React.createElement("div", {
    className: styles['button-container']
  }, /*#__PURE__*/React.createElement(_uiKit.ArticleHeading4, {
    textAlign: "right"
  }, "\u0417\u0430\u044F\u0432\u043A\u0430 \u043D\u0430 \u0438\u043F\u043E\u0442\u0435\u043A\u0443", /*#__PURE__*/React.createElement("br", null), "\u0431\u0435\u0437 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u0432"), /*#__PURE__*/React.createElement(_uiKit.LinkButton, {
    target: "_blank",
    href: _mortgageLink.MORTGAGE_LINK,
    theme: "fill_success_primary",
    size: "M",
    onClick: onButtonClick
  }, "\u041F\u043E\u0434\u0430\u0442\u044C \u0437\u0430\u044F\u0432\u043A\u0443 \u043E\u043D\u043B\u0430\u0439\u043D")));
};
exports.Banner = Banner;